<template>
  <nav class="lg:flex lg:justify-between lg:items-center pt-2 shadow-sm sticky top-0 bg-white z-10">
      <div class="lg:pl-24 px-2 w-full flex justify-between items-center">
        <div>
          <a href="#"><img src="../assets/img/logo.svg" class="h-auto w-48"></a>
        </div>
        <div class="block lg:hidden">
          <button @click="isOpen = !isOpen" type="button" class="mr-6 hover:text-gray-700 focus:outline-none focus:text-gray-700" aria-label="toggle menu">
              <svg class="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path v-if="!isOpen" fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd">
                </path>
                <path v-if="isOpen" fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd">
                </path>
              </svg>
            </button>
        </div>
    </div>
    <div :class="isOpen? 'block':'hidden'" class="lg:flex pt-2 rounded-md shadow-md lg:shadow-none px-6 mt-4 tracking-wide lg:mt-0 lg:pt-0 lg:pl-40 items-center w-full">
          <div class="block hover:bg-gray-100 hover:text-blue-700 py-2 px-3 cursor-pointer transition ease-out duration-500"><a href="">लगईन गर्नुहोस्</a></div>
          <div class="block hover:bg-gray-100 hover:text-blue-700 py-2 px-3 cursor-pointer transition ease-out duration-500"><a href="">खाता खोल्नुहोस</a></div>
          <div class="block bg-gray-200 hover:text-blue-700 py-2 px-3 cursor-pointer transition ease-out duration-500"><a href="">कामदार खोज्नुहोस् </a></div>
          <div class="block hover:bg-gray-100 hover:text-blue-700 py-2 px-3 mx-3 cursor-pointer text-sm transition ease-out duration-500"><a href="" class="flex items-center"><svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z" clip-rule="evenodd"></path></svg>EN</a></div>
    </div>
  </nav>
</template>

<script>
export default {
  data (){
    return {
      isOpen: false
    }
  }
}
</script>

<style>

</style>
